<script>
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import $ from "jquery";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";
import {useStore} from "vuex";

export default {
  name: "MyAuctions",
  components:{LoadingPage},
  setup() {

    let store = useStore()
    let HomePage = store.state.HomePage
    if (!HomePage.bid){
      router.push({name:'HomePage'})
    }
    let scroll = false

    onMounted(() => {
      scroll = true
    })
    onBeforeUnmount(() => {
      scroll = false
    })

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      if (scroll) {
        if (scrollPosition > 100) {
            $("#icon_add").removeClass('animate__fadeInUp');
            $("#icon_add").addClass('animate__fadeOutDown');
        } else {
          $("#icon_add").removeClass('animate__fadeOutDown');
          $("#icon_add").addClass('animate__fadeInUp');
        }
      }
    });

    let loading = ref(false)
    let bids = ref([])

    function load_bids() {

      loading.value = true

      FreeWorld.Heisenberg({}, 'shop/my_bids', true).then((res) => {

        loading.value = false

      bids.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_bids)
      })

    }
    load_bids()

    function open_products(id) {

      let div = document.getElementById('product' + id)
      let info = $("#info_prod" + id)
      let icon = $("#icon" + id)

      let rootFontSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('font-size'));
      let heightInRem = div.scrollHeight / rootFontSize;
      heightInRem = heightInRem.toFixed(1);

      if (div.style.height !== heightInRem + 'rem') {
        div.style.height = heightInRem + 'rem'
        info.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        icon.removeClass('min_rotate_icon').addClass('rotate_icon')
      } else {
        window.innerWidth > 800 ? div.style.height = '16rem' : div.style.height = '13rem'
        info.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
      }

    }
    function decreaseTimer() {
      // برای هر آیتم در آرایه bids
      bids.value.forEach(item => {
        // تقسیم تایمر به ساعت، دقیقه و ثانیه
        let [hours, minutes, seconds] = item.timer.split(':').map(Number);
        // کاهش یک ثانیه از تایمر
        seconds--;
        // اگر زمان به صفر رسید، زمان را به 0:0:0 تنظیم کنید
        if (seconds < 0) {
          seconds = 59;
          minutes--;
          if (minutes < 0) {
            minutes = 59;
            hours--;
            if (hours < 0) {
              hours = 0;
              minutes = 0;
              seconds = 0;
              // اگر زمان به پایان رسید، اقدامات مورد نظر را انجام دهید، مثلاً توقف تایمر
            }
          }
        }
        // به‌روزرسانی تایمر در آرایه data
        item.timer = `${hours}:${minutes}:${seconds}`;
      });
    }

    let update_timer = null

    onMounted(() => {
      update_timer = setInterval(decreaseTimer, 1000);
      window.addEventListener('resize', handleResize);
    })
    onBeforeUnmount(() => {
      clearInterval(update_timer)
      window.removeEventListener('resize', handleResize);
    })


    let windowWidth = ref()
    const handleResize = () => {
      windowWidth.value = window.innerWidth
    };

    watch(() => windowWidth.value, (newWidth) => {
      bids.value.forEach((item) => {
        let div = document.getElementById('product' + item.id);
        if (div) {
          newWidth > 800 ? div.style.height = '16rem' : div.style.height = '13rem'
        }
      });
    })

    return {

      loading,
      bids,
      open_products,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مزایده های من</p>
        <router-link :to="{name:'HomePage'}" class="">
        <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="bids.length === 0 && !loading" style="height: 45vh" class="d-flex justify-content-center align-items-end w-100 animate__animated animate__fadeIn">
      <div class="d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/auction.png" class="mb-4 w-30" alt="">
        <p class="font-4 font-bold">مزایده ای برای نمایش وجود ندارد!</p>
      </div>
    </div>

    <div v-else class="w-100 p-body ">

      <div v-for="item in bids" :key="item.id" class="position-relative animate__animated animate__fadeInRight">

        <div :id="'product' + item.id"
             class="overflow-hidden product text-decoration-none bg-white mb-4-5 shadow-custom p-2 rounded-4 position-relative">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column justify-content-around w-60">
              <div class="overflow-hidden">
                <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
              </div>


              <div class="overflow-hidden">
                <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 25}">از برند {{ item.brand }}</p>
              </div>

              <div class="d-flex align-items-end mb-2">
                <img src="../assets/img/package2.png" class="icon-size-1">

                <p style="white-space: nowrap" class="font-6 mx-1">حجم محصول مزایده :</p>

                <div class="overflow-hidden">
                  <p :class="item.pnum.toString().length + item.unit.length > 10 ? 'txtoverflow':''"
                     class="font-5 font-color font-bold d-flex align-items-center">
                    <span class="mx-1">{{ item.pnum }} عدد</span>
                    <span class="">{{ item.unit }}</span>
                  </p>
                </div>
              </div>

              <div class="d-flex align-items-end">
                <img src="../assets/img/credit2.png" class="icon-size-1">

                <p class="font-6 mr-1">قیمت پایه مزایده :</p>

                <p :class="item.price.toString().length > 10 ? 'txtoverflow':''"
                   class="mx-1 font-color font-bold d-flex align-items-end">
                  <span class="font-5">{{ item.price.toLocaleString() }}</span>
                  <span class="font-6 mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr my-2"></div>

            </div>


            <div class="img_prod rounded-3 animated-background">
              <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
            </div>

          </div>

          <div class="d-flex align-items-center justify-content-between mb-4-5 mt-2">

            <div class="d-flex align-items-center">
              <img class="icon-size-0-5 ml-2" src="../assets/img/store_color.svg" alt="">

              <div class="overflow-hidden d-flex align-items-center w-100">
                <div class="d-flex align-items-center w-100" :class="item.shopname.length > 20 ? 'txtoverflow':''">
                  <p class="ml-1 font-5">{{ item.shopname }}</p>

                  <img class="icon-size-1" v-if="item.shoprate == 1" src="../assets/img/rate1.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 2" src="../assets/img/rate2.svg" alt="">
                  <img class="icon-size-1" v-else-if="item.shoprate == 3" src="../assets/img/rate3.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 4" src="../assets/img/rate4.svg" alt="">
                  <img class="icon-size-1" v-else-if="item.shoprate == 5" src="../assets/img/rate5.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 6" src="../assets/img/rate6.svg" alt="">
                </div>
              </div>
            </div>

            <router-link v-if="item.start && item.status !== 2" :to="{name:'AuctionInformation' , params:{bid:item.id}}" class="text-decoration-none d-flex justify-content-center text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده شرکت کنندگان</router-link>
            <div v-else-if="!item.start && item.status !== 2" class="text-decoration-none d-flex justify-content-center text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">هنوز شروع نشده</div>
            <div v-else-if="item.status === 2" class="text-decoration-none d-flex justify-content-center text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">تمام شده</div>
          </div>

          <div :id="'info_prod' + item.id" class="animate__animated rounded-3 p-body py-3 mb-4 drop_shadow">
            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/clock.png" class="icon-size-1">

              <div v-if="item.start && item.status !== 2" class="d-flex align-items-center">
                <p class="m-0 me-2 font-6">زمان باقی مانده مزایده:</p>
                <p class="m-0 me-2 font-5 font-bold font-color">{{ item.timer }}</p>
              </div>

              <p v-else-if="!item.start && item.status !== 2" class="font-5 font-color-red me-2">مزایده هنوز شروع نشده</p>
              <p v-else-if="item.status === 2" class="font-5 font-color-red me-2">مزایده به اتمام رسیده</p>
            </div>

            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/bid.png" class="icon-size-1">
              <p class="mx-2 font-6">آخرین قیمت مزایده :</p>
              <div class="d-flex justify-content-center align-items-center">
                <p class="font-5 font-bold font-color">{{ item.price_last.toLocaleString() }}</p>
                <p class="font-6 mr-1 font-bold font-color">تومان</p>
              </div>
            </div>

            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/increase.png" class="icon-size-1">
              <p class="mx-2 font-6">مبلغ هر گام :</p>
              <div class="d-flex justify-content-center align-items-center">
                <p class="font-5 font-bold font-color">{{ item.price_step.toLocaleString() }}</p>
                <p class="font-6 mr-1 font-bold font-color">تومان</p>
              </div>
            </div>

            <div class="d-flex justify-content-start align-items-center">
              <img src="../assets/img/information.svg" class="icon-size-1">
              <p class="mx-2 font-6">وضعیت مزایده :</p>

                <p class="font-6 font-bold" :class="item.info.result === 'درحال برگذاری - برنده مشخص نشده' || item.info.result === 'مزایده شروع نشده است' ? 'font-color':'font-color-green'">{{ item.info.result }}</p>
            </div>
          </div>
        </div>

        <div @click="open_products(item.id)"
             class="icon_show rounded-pill bg-white shadow-custom position-absolute d-flex justify-content-center align-items-center">
          <img :id="'icon' + item.id" src="../assets/img/bottomarrow.png" class="min_rotate_icon position-absolute icon-size-0-5">
        </div>
      </div>

    </div>

    <div id="icon_add" dir="ltr" class="animate__animated animate__fadeInUp position-fixed max_width w-100" style="bottom: 5%">
      <router-link :to="{name:'AddAuctions'}">
        <img src="../assets/img/icon_add_products.svg" class="ml-5" style="width: 60px;height: 60px">
      </router-link>
    </div>

  </div>

</template>


<style scoped>

.icon_show {
  left: 50%;
  bottom: -1.3rem;
  transform: translate(-50%, 0);
  padding: 1.3rem;
}

.product {
  transition: .5s;
}

@media (min-width: 800px) {
  .img_prod {
    width: 25% !important;
    height: 12rem !important;
  }
  .product{
    height: 16rem;
  }
}
@media (max-width: 799px) {
  .product{
    height: 13rem;
  }
}
.img_prod {
  width: 35%;
  height: 8.5rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 15px;
}

.drop_shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 55px -12px inset, rgba(0, 0, 0, 0.3) 0px 0px 0px 0px inset, inset 0 0 15px 0 #c7c7c7;
}

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(3deg);
  transition: .5s;
}

</style>